<template>
  <Transition name="fade">
    <div
      v-show="loaded"
      class="min-h-screen flex items-center justify-center bg-[#fafbfb]">
      <div class="w-[30rem] flex flex-col items-center gap-24 bg-white border border-neutral-100/10 rounded-md p-48 shadow-sm">
        <Vue3Lottie
          :animation-data="animateMaintenance"
          :height="280"
          :width="280"
          @on-animation-loaded="loaded = true" />
        <h1 class="text-headline-1 text-neutral-90 text-center text-[1.75rem]">
          Sistema em Manutenção
        </h1>
        <p class="text-pararaphy-2 text-neutral-60 text-center leading-relaxed">
          Estamos realizando melhorias no sistema.<br>
          Por favor, tente novamente em alguns minutos.
        </p>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import animateMaintenance from 'src/assets/lottie/maintenance.json'

import { ref } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'

const loaded = ref(false)
</script>

<style lang="sass" scoped></style>
